<template>
  <div class="alert-info-simple">
    <slot />
  </div>
</template>
